import { render } from "./ForVenuesPage.vue?vue&type=template&id=85f490de&scoped=true"
import script from "./ForVenuesPage.vue?vue&type=script&lang=js"
export * from "./ForVenuesPage.vue?vue&type=script&lang=js"

import "./ForVenuesPage.vue?vue&type=style&index=0&id=85f490de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f490de"]])

export default __exports__